import { Hospital } from 'lucide-react';
import { ExistingPatient } from '../../../types';
import { getProfileColor } from '@/utils/helpers';
import { formatPhoneNumber } from '../../../utils/phoneUtils';
import { formatAddress } from '../../../utils/addressUtils';
import { format, parseISO } from 'date-fns';

interface PatientDemographicsProps {
  patient: ExistingPatient;
}

export const PatientDemographics = ({ patient }: PatientDemographicsProps) => {
  const profileColor = getProfileColor(patient.organizationProfile.avatarType);

  return (
    <div className="rounded-lg border bg-white p-6">
      <div
        className={`grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 ${
          patient.patientReferenceId ? 'xl:grid-cols-8' : 'xl:grid-cols-7'
        }`}
      >
        {patient.patientReferenceId && (
          <div className="min-w-0">
            <div className="text-sm font-medium text-gray-900">
              Patient Ref. ID:
            </div>
            <div className="mt-1 text-sm break-words text-gray-900">
              {patient.patientReferenceId}
            </div>
          </div>
        )}
        <div>
          <div className="text-sm font-medium text-gray-900">Patient Key</div>
          <div className="mt-1 text-sm text-gray-900">
            {patient.key || '--'}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">Profile</div>
          <div className="mt-1 flex items-center gap-2 text-sm text-gray-900">
            <Hospital className="size-4" style={{ color: profileColor }} />
            {patient.organizationProfile.displayName}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">DOB</div>
          <div className="mt-1 text-sm text-gray-900">
            {patient.dateOfBirth
              ? format(parseISO(patient.dateOfBirth), 'MM/dd/yyyy')
              : '--'}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">Gender</div>
          <div className="mt-1 text-sm text-gray-900 capitalize">
            {patient.genderName || '--'}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">Phone Number</div>
          <div className="mt-1 text-sm text-gray-900">
            {patient.contact.phoneNumber
              ? formatPhoneNumber(patient.contact.phoneNumber)
              : '--'}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">Email</div>
          <div className="mt-1 text-sm text-gray-900">
            {patient.contact.emailAddress || '--'}
          </div>
        </div>
        <div>
          <div className="text-sm font-medium text-gray-900">Address</div>
          <div className="mt-1 text-sm whitespace-pre-line text-gray-900">
            {formatAddress(patient.address) || '--'}
          </div>
        </div>
      </div>
    </div>
  );
};
